const database = [
  {
    technology: 'MySQL',
  },
  {
    technology: 'PostgreSQL',
  },
  {
    technology: 'PL/SQL',
  },
  {
    technology: 'Neo4j',
  },
];

export default database;
